export const sanitizeDate = (date) => {
    if (typeof date === 'string') {
        return new Date(date);
    }
    return date;
}

export const toLongDate = (date) => {
    const d = sanitizeDate(date);
    return new Intl.DateTimeFormat('en-US', {
        dateStyle: 'full',
        timeStyle: 'short',
    }).format(d);
};

export const toShortDate = (date) => {
    const d = sanitizeDate(date);
    return new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium'
    }).format(d);
};

export const toShortNumDate = (date) => {
    const d = sanitizeDate(date);
    return new Intl.DateTimeFormat('en-US').format(d);
};